import { render, staticRenderFns } from "./CriterioDetailTreeView.vue?vue&type=template&id=4af96618&scoped=true&"
import script from "./CriterioDetailTreeView.vue?vue&type=script&lang=js&"
export * from "./CriterioDetailTreeView.vue?vue&type=script&lang=js&"
import style0 from "./CriterioDetailTreeView.vue?vue&type=style&index=0&id=4af96618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af96618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardActions,
  VCardText,
  VCheckbox,
  VChip,
  VDataTable,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VSelect,
  VSnackbar,
  VSpacer,
  VTextField,
  VTooltip,
})
